import React from 'react';

import ItemDetailSkeleton from '~/components/Details/ItemDetail/ItemDetailSkeleton';

import { ItemsSkelleton } from './styles';

const ProfileInfoSkelleton = () => {
  return (
    <ItemsSkelleton>
      {Array.from(Array(6)).map((_, index) => (
        <ItemDetailSkeleton key={index} />
      ))}
    </ItemsSkelleton>
  );
};

export default ProfileInfoSkelleton;
